module.exports = __webpack_public_path__ + "static/img/P2.3b3e604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P2.png
// module id = bFKt
// module chunks = 0